import type { ApplicationError } from '~~/core/helpers/result';

function asRecord(value: unknown): Record<string, unknown> | undefined {
	return value !== null && typeof value === 'object' && !Array.isArray(value)
		? (value as Record<string, unknown>)
		: undefined;
}

function isExplicitNotFoundMessage(value: unknown): boolean {
	if (typeof value !== 'string') return false;

	const message = value
		.trim()
		.toLowerCase()
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/\.$/, '');

	return message === 'agent not found' || message === 'corretor nao encontrado';
}

/**
 * A generic HTTP 404 can mean the endpoint is unavailable. Only remove an agent
 * filter when the response explicitly identifies the agent as missing.
 */
export function isAgentNotFoundError(error: ApplicationError): boolean {
	const originalError = asRecord(error.originalErrorObject);

	if (originalError?.statusCode !== 404) return false;

	const responseData = asRecord(originalError.responseData);
	const data = asRecord(responseData?.data);

	return (
		responseData?.code === 'AGENT_NOT_FOUND' ||
		data?.code === 'AGENT_NOT_FOUND' ||
		isExplicitNotFoundMessage(responseData?.detail) ||
		isExplicitNotFoundMessage(responseData?.message) ||
		isExplicitNotFoundMessage(responseData?.statusMessage) ||
		isExplicitNotFoundMessage(originalError.statusMessage)
	);
}
